module.exports = __webpack_public_path__ + "img/Logo.52526040.png";